export default __webpack_public_path__ + "static/media/adir-sommer.eb64541e.jpeg";